import React from 'react';
import styled from 'styled-components';

import { ICON_CLOSE } from 'assets/icons';
import Column from 'components/common/Column';
import CommonImage from 'components/common/CommonImage';
import Row from 'components/common/Row';
import Text from 'components/common/Text';
import ModalContainer from 'containers/ProductRegist/components/common/ModalContainer';

const RegistFilterButton = styled.button<{ $isSelected: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px 16px;
  border-radius: 8px;
  border: ${props =>
    props.$isSelected ? '1.5px solid #1b1c1e' : '1px solid #DBDCDF'};
  background: ${props => (props.$isSelected ? '#f7f7f8' : '#fff')};

  color: var(--gray-gray-09, #1b1c1e);

  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 142.857% */
  letter-spacing: -0.6px;
`;

interface ListSearchContainerIProps {
  isMobile: boolean;
  termType: string;
  handleSetTermType: (type: string) => void;
  handleResetTermType: () => void;
  handleAcceptFilter: () => void;
  onClose: () => void;
}

const ListSearchContainer: React.FC<ListSearchContainerIProps> = props => {
  const {
    isMobile,
    termType,
    handleSetTermType,
    handleResetTermType,
    handleAcceptFilter,
    onClose,
  } = props;

  const renderSettlementTerm = (): JSX.Element => {
    return (
      <Column gap="12px" align="flex-start">
        <Text color="#1B1C1E" size="16px">
          조회 기간
        </Text>
        <Row
          gap="12px"
          justifyContent="flex-start"
          style={{ flexWrap: 'wrap' }}
        >
          <RegistFilterButton
            $isSelected={termType === 'all'}
            onClick={() => handleSetTermType('all')}
          >
            전체
          </RegistFilterButton>
          <RegistFilterButton
            $isSelected={termType === '1month'}
            onClick={() => handleSetTermType('1month')}
          >
            최근 1개월
          </RegistFilterButton>
          <RegistFilterButton
            $isSelected={termType === '6month'}
            onClick={() => handleSetTermType('6month')}
          >
            최근 6개월
          </RegistFilterButton>
          <RegistFilterButton
            $isSelected={termType === '1year'}
            onClick={() => handleSetTermType('1year')}
          >
            최근 1년
          </RegistFilterButton>
          <RegistFilterButton
            $isSelected={termType === '5year'}
            onClick={() => handleSetTermType('5year')}
          >
            최근 5년
          </RegistFilterButton>
        </Row>
      </Column>
    );
  };

  return (
    <ModalContainer
      isMobile={isMobile}
      isAbled={true}
      onCloseText="초기화"
      onClose={handleResetTermType}
      onAcceptText="적용"
      onClick={() => {
        handleAcceptFilter();
        onClose();
      }}
    >
      <Column style={{ padding: '0 20px' }}>
        <Row style={{ padding: '16px 0', width: '100%' }}>
          <CommonImage
            src={ICON_CLOSE}
            onClick={onClose}
            style={{ position: 'absolute', left: '20px' }}
          />
          <Text color="#000" size="16px" weight={600}>
            검색
          </Text>
        </Row>
        <Column gap="32px" style={{ padding: '12px 0' }} align="flex-start">
          {renderSettlementTerm()}
        </Column>
      </Column>
    </ModalContainer>
  );
};

export default ListSearchContainer;
